import axios from 'axios';
import { flattenDeep } from 'lodash';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import { constant } from '../../../Utils/constants';
import TableSelect from '../../../Widgets/TableSelect';
import React, { useState, useEffect, useRef } from 'react';
import translation from '../../../../../commons/translation';
import InputComponent from '../../../Widgets/InputComponent';
import localStorage from '../../../../../utils/localStorage';

import { DownOutlined, SearchOutlined, PlusOutlined } from '@ant-design/icons';
import { Form, message, Select, Divider, Space, Row, Col, Input, Tree, Modal,Button } from 'antd';
import {
  getSitesList,
  // getLocationByAsset,
  submitMaster,
  getDeviceList,
  questionsListMaster,
  getinspectionAreaList,
  getinspectionItemList,
  getAnswersList,
  getWorkPlanningList,
  saveQuestionData,
  saveAreaData,
  saveItemData,
  getEquipmentRecord,
  // getHierarchyList,
  // getEquipmentHierarchy,
  getInspectionData
} from '../.././../Utils/FormCalls';
import {
  API_DEVICE,
  // API_HIERARCHYMODULE,
  API_INSPECTIONQUESTIONS
} from '../../../../../commons/api';
import dayjs from 'dayjs';

const { Option } = Select;
const type = 'Item';
const urlList = {
  insert: API_INSPECTIONQUESTIONS.INSERT,
  delete: 'api/masterItems/getById?Id=3',
  getbyId: API_INSPECTIONQUESTIONS.GetById
};
const fileData = new FormData();

const InspectionMaster = (props) => {
  const [formObject, setFormObject] = useState(props.formObject && Object.keys(props.formObject).length > 0 ? props.formObject : {});
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const [visible, setVisible] = useState(false);
  const [, setDeviceList] = useState([]);
  const [questionList, setQuestionList] = useState([]);
  const [inspectionAreaList, setInspectionAreaList] = useState([]);
  const [inspectionItemList, setInspectionItemList] = useState([]);
  // const [status] = useState('false');
  const [AnswerList, setAnswerList] = useState([]);
  const [WorkPlanList, setWorkPlanList] = useState([]);
  // const [open] = useState('false');
  const [viewQuestionModal, setViewQuestionModal] = useState(false);
  // const [ViewModal, setViewModal] = useState(false);
  const [viewAreaModal, setViewAreaModal] = useState(false);
  const [viewItemModal, setViewItemModal] = useState(false);
  const [, setEquipmentRecord] = useState([]);
  const [, setGetById] = useState('');
  const [, setAnswerKey] = useState([]);
  // const [hierarchyList, setHierarchyList] = useState([]);
  const [formObjectId, setFormObjectId] = useState('');
  const [treeData, setTreeData] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [tableData, setTableData] = useState([]);

  const QuestionRef = useRef();
  const deviceRef = useRef();
  const areaRef = useRef();
  const ItemRef = useRef();
  // const optionRef = useRef();


  useEffect(() => {
    const fetchData = async () => {
      // try {
      //   await getEquipmentHierarchy();
      //   let hierarchyList = await getHierarchyList();
      //   setHierarchyList(hierarchyList);
      // } catch (error) {
      //   message.warning(`${error.message}`);
      // }
      try {
        let sitesList = await getSitesList();
        let formObject = QuestionRef.current.getFieldsValue();
        formObject = {
          ...formObject,
          SiteId: sitesList && sitesList[0] && sitesList[0].Id ? sitesList[0].Id : ''
        };
        QuestionRef.current.setFieldsValue(formObject);
        setFormObject(formObject);
      } catch (error) {
        message.warning(`${error.message}`);
      }
      try {
        let deviceList = await getDeviceList();
        setDeviceList(deviceList);
      } catch (error) {
        message.warning(`${error.message}`);
      }
      try {
        let AnswerList = await getAnswersList();
        setAnswerList(AnswerList);
      } catch (error) {
        message.warning(`${error.message}`);
      }
      try {
        let WorkPlanList = await getWorkPlanningList();
        setWorkPlanList(WorkPlanList);
      } catch (error) {
        message.warning(`${error.message}`);
      }
      try {
        let questionList = await questionsListMaster();
        setQuestionList(questionList);
      } catch (error) {
        message.warning(`${error.message}`);
      }
      try {
        let inspectionAreaList = await getinspectionAreaList();
        setInspectionAreaList(inspectionAreaList);
      } catch (error) {
        message.warning(`${error.message}`);
      }
      try {
        let inspectionItemList = await getinspectionItemList();
        setInspectionItemList(inspectionItemList);
      } catch (error) {
        message.warning(`${error.message}`);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    if (props.formObject && Object.keys(props.formObject).length === 0 && Object.keys(formObject).length === 0) {
      onReset();
    }
    if (props.formObject && Object.keys(props.formObject).length === 0) {
      if (QuestionRef.current) {
        QuestionRef.current.setFieldsValue(props.formObject);
      }
    }
    if (props.formObject !== formObject) {
      setFormObject(props.formObject);
    }
  }, [props]);

  // const handleChange = async (value, key) => {
  //   let updatedFormObject = { ...formObject, [key]: value };
  //   if (key === 'DeviceId') {
  //     let selectedDevice = deviceList.filter((item) => item.Id === value);
  //     let location = await getLocationByAsset(selectedDevice[0]);
  //     updatedFormObject = {
  //       ...updatedFormObject,
  //       LocationId: location.data.Name
  //     };
  //   }
  //   if (QuestionRef.current) QuestionRef.current.setFieldsValue(updatedFormObject);
  //   setFormObject(updatedFormObject);
  // };

  const onAnswerChange = (answerKey) => {
    setAnswerKey(answerKey);
  };

  // const fileUpload = async (values, key, fileDataObject) => {
  //   let updatedFormObject = QuestionRef.current.getFieldsValue();
  //   if (updatedFormObject[key]) {
  //     updatedFormObject[key].push(...values);
  //   } else {
  //     updatedFormObject[key] = values;
  //   }
  //   updatedFormObject[key] = updatedFormObject[key].reduce((acc, current) => {
  //     const x = acc.find((item) => item.Name === current.Name);
  //     if (!x) {
  //       return acc.concat([current]);
  //     } else {
  //       return acc;
  //     }
  //   }, []);
  //   updatedFormObject = { ...updatedFormObject, [key]: updatedFormObject[key] };
  //   fileData.append('files', fileDataObject);
  //   if (QuestionRef.current) QuestionRef.current.setFieldsValue(updatedFormObject);
  //   setFormObject(updatedFormObject);
  // };

  const onFormSubmit = async (values) => {
    const siteId = localStorage.get('currentSite');
    let payload = {
      ...formObject,
      ...values,
      ...(formObject && formObject.Id ? { Id: formObject.Id } : ''),
      SiteId: siteId
    };
    let statusResponse = await submitMaster(urlList.insert, payload, fileData, type);
    if (statusResponse && statusResponse.message) {
      message.success(statusResponse.message);
      getEquipmentHierarchy();
    } else if (statusResponse && statusResponse.Error) {
      message.error(statusResponse.Error);
    }
  };

  const onReset = () => {
    if (QuestionRef.current) QuestionRef.current.resetFields();
  };

  const onDrawerCancel = () => {
    setVisible(false);
  };

  const onModalOk = () => {
    setVisible(false);
  };

  // const onChangeQuestion = () => {
  //   let updatedFormObject = QuestionRef.current.getFieldsValue();
  //   setFormObject(updatedFormObject);
  //   QuestionRef.current.setFieldsValue(updatedFormObject);
  // };

  // const openCollapse = () => {
  //   setOpen(true);
  // };

  const onAreaClose = (e) => {
    if (e.target.tagName === 'DIV') {
      e.preventDefault();
      message.error('Please Click On Cancel');
    } else {
      setViewAreaModal(false);
      areaRef.current.resetFields();
    }
  };

  const onFormAreaSubmit = (e) => {
    e.preventDefault();
    areaRef.current.validateFields().then(async (values) => {
      let payload = {
        data: { ...values },
        MasterCode: 'Inspection_Areas',
        ActionType: 'create',
        Type: 'WithSiteId'
      };
      let CreateArea = await saveAreaData(payload);
      if (CreateArea) {
        message.success(CreateArea.message);
        let inspectionAreaList = await getinspectionAreaList();
        setInspectionAreaList(inspectionAreaList);
        setViewAreaModal(false);
        if (areaRef.current) areaRef.current.resetFields();
        let updatedFormObject = QuestionRef.current.getFieldsValue();
        let areaId = inspectionAreaList.filter((item) => item.Area === values.Area);
        if (areaId && areaId[0]) {
          updatedFormObject = { ...updatedFormObject, AreaId: areaId[0].Id };
          QuestionRef.current.setFieldsValue(updatedFormObject);
          setFormObject(updatedFormObject);
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  };

  const onItemClose = (e) => {
    if (e.target.tagName === 'DIV') {
      e.preventDefault();
      message.error('Please Click On Cancel');
    } else {
      setViewItemModal(false);
      if (ItemRef.current) ItemRef.current.resetFields();
    }
  };

  const onFormItemSubmit = (e) => {
    e.preventDefault();
    ItemRef.current.validateFields().then(async (values) => {
      let payload = {
        MasterCode: 'Inspection_Items',
        ActionType: 'create',
        Type: 'WithSiteId',
        data: { ...values }
      };
      let CreateItemData = await saveItemData(payload);
      if (CreateItemData) {
        message.success(CreateItemData.message);
        let inspectionItemList = await getinspectionItemList();
        setInspectionItemList(inspectionItemList);
        setViewItemModal(false);
        if (ItemRef.current) ItemRef.current.resetFields();
        let updatedFormObject = QuestionRef.current.getFieldsValue();
        let itemId = inspectionItemList.filter((item) => item.Item === values.Item);
        if (itemId && itemId[0]) {
          updatedFormObject = { ...updatedFormObject, ItemId: itemId[0].Id };
          QuestionRef.current.setFieldsValue(updatedFormObject);
          setFormObject(updatedFormObject);
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  };

  const adQuestionForm = () => {
    setViewQuestionModal(true);
    if (deviceRef.current) deviceRef.current.resetFields();
  };

  // const addAnswerModal = () => {
  //   setViewModal(true);
  //   if (optionRef.current) optionRef.current.resetFields();
  // };

  const onQuestionsClose = (e) => {
    if (e.target.tagName === 'DIV') {
      e.preventDefault();
      message.error('Please Click On Cancel');
    } else {
      setViewQuestionModal(false);
    }
  };

  // const onModalClose = (e) => {
  //   if (e.target.tagName === 'DIV') {
  //     e.preventDefault();
  //     message.error('Please Click On Cancel');
  //   } else {
  //     setViewModal(false);
  //   }
  // };

  const onModalFormSubmit = () => {
    deviceRef.current.validateFields().then(async (values) => {
      let payload = { ...values };
      let createDeviceResponse = await saveQuestionData(payload);
      if (createDeviceResponse) {
        message.success(createDeviceResponse.message);
        let questionList = await questionsListMaster();
        let updatedFormObject = QuestionRef.current && QuestionRef.current.getFieldsValue();
        let questionId = questionList.filter((item) => item.Question === values.Question);
        updatedFormObject = {
          ...updatedFormObject,
          QuestionIds: [
            ...(updatedFormObject && updatedFormObject['QuestionIds'] ? updatedFormObject['QuestionIds'] : []),
            questionId[0].Id
          ]
        };
        QuestionRef.current && QuestionRef.current.setFieldsValue(updatedFormObject);
        setFormObject(updatedFormObject);
        setViewQuestionModal(false);
        setQuestionList(questionList);
        setVisible(false);
      }
    }).catch((error) => {
      console.log(error);
    });
  };

  const onHandleChange = async (e, type) => {
    let updatedFormObject = QuestionRef.current.getFieldsValue();
    updatedFormObject = { ...updatedFormObject };
    let payload = {
      AreaId: updatedFormObject.AreaId,
      ItemId: updatedFormObject.ItemId
    };
    if (type === 'ItemId') {
      let EquipmentRecord = await getEquipmentRecord(payload);
      let getById = EquipmentRecord && EquipmentRecord[0] && EquipmentRecord[0].Id;
      setEquipmentRecord(EquipmentRecord);
      setGetById(getById);
      updatedFormObject = {
        ...updatedFormObject,
        QuestionIds: EquipmentRecord && EquipmentRecord[0] ? EquipmentRecord[0].QuestionIds : []
      };
      setFormObject(updatedFormObject);
    }
    QuestionRef.current.setFieldsValue(updatedFormObject);
    setFormObject(updatedFormObject);
  };

  // const getHierarchyLevels = () => {
  //   const siteId = localStorage.get('currentSite');
  //   let payload = {
  //     HierarchyCode: hierarchyList && Array.isArray(hierarchyList) && hierarchyList[0] ? hierarchyList[0].HierarchyCode : null,
  //     Type: 'Device'
  //   };
  //   const accessToken = localStorage.get('accessToken');
  //   let headers = {
  //     method: 'GET',
  //     url: `${API_HIERARCHYMODULE.GetHierarchyLevels}?SiteId=${siteId}&HierarchyCode=${payload.HierarchyCode}&Type=${payload.Type}`,
  //     headers: {
  //       Authorization: `Bearer ${accessToken}`
  //     }
  //   };
  //   return axios(headers)
  //     .then(({ data }) => {
  //       if (Array.isArray(data)) {
  //         setTreeData(data);
  //         setVisible(true);
  //         setFormObject(QuestionRef.current.getFieldsValue());
  //       }
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     });
  // };

  const getDeviceData = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let headers = {
      method: 'GET',
      url: `${API_DEVICE.LIST}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(headers)
      .then(({ data }) => {
        setTableData(data);
        setVisible(true);
        setFormObject(QuestionRef.current.getFieldsValue());
      })
      .catch(function () { });
  };

  const TableDropdownChange = (value) => {
    let updatedFormObject = QuestionRef.current.getFieldsValue();
    updatedFormObject = { ...updatedFormObject, Equipment: value.AliasCode };
    setFormObject(updatedFormObject);
    setVisible(true);
    QuestionRef.current.setFieldsValue(updatedFormObject);
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record && record[dataIndex] && record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const getEquipmentHierarchy = async () => {
    let treeData = await getEquipmentHierarchy();
    if (treeData) {
      expandAll(treeData);
    }
    setTreeData(treeData);
  };

  const renderTreeNodes = (data) => {
    return (
      data &&
      Array.isArray(data) &&
      data.map((item) => {
        if (item.children && item.children.length > 0) {
          return (
            <Tree.TreeNode
              title={item && !item.ParentId ? `${item.Code} (${item.Name})` : item.Name}
              key={item.key}
              dataRef={item}
            >
              {renderTreeNodes(item.children, item)}
            </Tree.TreeNode>
          );
        }
        return <Tree.TreeNode key={item.key} title={<div>{item.DisplayCode}({item.Name})</div>} dataRef={item} />;
      })
    );
  };

  const onExpand = (expandedKeys) => {
    setExpandedKeys(expandedKeys);
  };

  const expandAll = async (treeData) => {
    let expandedKeys = await getAllKeys(treeData);
    setExpandedKeys(expandedKeys);
  };

  const getAllKeys = (data) => {
    const nestedKeys =
      data &&
      Array.isArray(data) &&
      data.map((node) => {
        let childKeys = [];
        if (node.children) {
          childKeys = getAllKeys(node.children);
        }
        return [childKeys, node.key];
      });
    return flattenDeep(nestedKeys);
  };

  const onSelect = async (selectedKeys, info) => {
    let status =
      info &&
      info['selectedNodes'] &&
      info['selectedNodes'][0] &&
      info['selectedNodes'][0]['dataRef'] &&
      info['selectedNodes'][0]['dataRef']['Type'] &&
      info['selectedNodes'][0]['dataRef']['Type'] === 'Items';
    if (status) {
      let updatedFormObject = {};
      let dataRef = info['selectedNodes'][0]['dataRef'];
      let questionPayload = {
        Equipment: dataRef && dataRef['MainParentId'] ? dataRef['MainParentId'] : '',
        AreaId: dataRef && dataRef['ParentId'] ? dataRef['ParentId'] : '',
        ItemId: dataRef && dataRef['Code'] ? dataRef['Code'] : '',
        currentDate: dayjs().utc().format('YYYY-MM-DD')
      };

      let data = await getInspectionData(questionPayload);
      if (data && data[0]) {
        updatedFormObject = data[0];
        setFormObject(updatedFormObject);
        setFormObjectId(updatedFormObject.Id);
        if (updatedFormObject) {
          QuestionRef.current.setFieldsValue(updatedFormObject);
        }
      }
    } else if (status === false) {
      message.error('Please Select Item');
    }
  };

  const setNewRecord = async () => {
    QuestionRef.current.resetFields();
    setFormObject({});
  };

  return (
    <>
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        <div
          style={{
            borderRight: '1px dashed white',
            width: '50%',
            flex: '10%',
            overflowY: 'auto',
            height: window.innerHeight - 250
          }}
        >
          <Tree
            onExpand={onExpand}
            expandedKeys={expandedKeys}
            style={{ width: '100%', flex: '50%', padding: '20px' }}
            onSelect={onSelect}
            showLine
            defaultExpandAll={true}
            switcherIcon={<DownOutlined />}
          >
            {renderTreeNodes(treeData)}
          </Tree>
        </div>
        <div
          style={{
            width: '100%',
            flex: '50%',
            padding: '10px',
            borderLeft: '3px dashed steelblue'
          }}
        >
          <Form
            name="InspectionMasters"
            ref={QuestionRef}
            className="collapse"
            onFinish={(data) => onFormSubmit(data, formObjectId)}
            layout="horizontal"
            labelCol={{ flex: '250px' }}
            labelAlign="right"
            labelWrap
            validateMessages={{
              required: '${label} is required!',
              types: {
                email: '${label} is not a valid email!',
                number: '${label} is not a valid number!'
              },
              number: {
                range: '${label} must be between ${min} and ${max}'
              },
              pattern: {
                mismatch: '${label} does not match pattern'
              }
            }}
          >
            <Form.Item>
              <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                {formObject && formObject.Id ? (
                  <Button htmlType="submit">
                    {translation(translationCache, constant.update)}
                  </Button>
                ) : (
                  <Button htmlType="submit">
                    {translation(translationCache, constant.submit)}
                  </Button>
                )}
                <Button
                  type="primary"
                  style={{ marginRight: '5px' }}
                  onClick={() => {
                    setNewRecord();
                  }}
                >
                  {translation(translationCache, 'Add')}
                </Button>
              </div>
            </Form.Item>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              <Form.Item
                style={{
                  width: '100%',
                  flex: '100%'
                }}
                label={translation(translationCache, constant.equipment)}
                name="Equipment"
                rules={[{ required: true }]}
              >
                <InputComponent
                  disabled={true}
                  suffix={
                    <DownOutlined
                      style={{
                        color: '#1a3b5c',
                        cursor: formObject && formObject.Id ? 'not-allowed' : null,
                        opacity: formObject && formObject.Id ? '0.8' : null
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        if (formObject && !formObject.Id) {
                          getDeviceData('visible');
                        }
                      }}
                    />
                  }
                  style={{ width: '70%' }}
                  placeholder={translation(translationCache, `Select ${constant.equipment}`)}
                />
              </Form.Item>
              <Form.Item
                style={{ width: '100%', flex: '100%' }}
                label={translation(translationCache, constant.inspectionArea)}
                name="AreaId"
                rules={[{ required: true }]}
              >
                <Select
                  style={{ width: '70%' }}
                  placeholder={translation(translationCache, 'Select Inspection Area')}
                  onSelect={(e) => onHandleChange(e, 'AreaId')}
                  showArrow={true}
                  dropdownRender={(menu) => (
                    <>
                      {menu}
                      <Divider style={{ margin: '8px 0' }} />
                      <Space style={{ padding: '0 8px 4px' }}>
                        <Button
                          type="dashed"
                          icon={<PlusOutlined />}
                          onClick={() => setViewAreaModal(true)}
                        >
                          {translation(translationCache, constant.addArea)}
                        </Button>
                      </Space>
                    </>
                  )}
                >
                  {inspectionAreaList && Array.isArray(inspectionAreaList) && inspectionAreaList.map((area, index) => (
                    <Option key={index} value={area.Id}>
                      {area.Area}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                style={{ width: '100%', flex: '100%' }}
                className="label"
                label={translation(translationCache, constant.inspectionItems)}
                name="ItemId"
                rules={[{ required: true }]}
              >
                <Select
                  style={{ width: '70%' }}
                  placeholder={translation(translationCache, 'Select Inspection Items')}
                  onSelect={(e) => onHandleChange(e, 'ItemId')}
                  showArrow={true}
                  dropdownRender={(menu) => (
                    <>
                      {menu}
                      <Divider style={{ margin: '8px 0' }} />
                      <Space style={{ padding: '0 8px 4px' }}>
                        <Button
                          type="dashed"
                          icon={<PlusOutlined />}
                          onClick={() => setViewItemModal(true)}
                        >
                          {translation(translationCache, constant.addItems)}
                        </Button>
                      </Space>
                    </>
                  )}
                >
                  {inspectionItemList && Array.isArray(inspectionItemList) && inspectionItemList.map((device, index) => (
                    <Option key={index} value={device.Id}>
                      {device.Item}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                style={{ width: '100%' }}
                className="label"
                label={translation(translationCache, constant.question)}
                name="QuestionIds"
                rules={[{ required: true }]}
              >
                <Select
                  style={{ width: '70%' }}
                  mode="multiple"
                  placeholder={translation(translationCache, 'Select Question')}
                  showArrow={false}
                  dropdownRender={(menu) => (
                    <>
                      {menu}
                      <Divider style={{ margin: '8px 0' }} />
                      <Space style={{ padding: '0 8px 4px' }}>
                        <Button
                          type="dashed"
                          icon={<PlusOutlined />}
                          onClick={adQuestionForm}
                        >
                          {translation(translationCache, 'Add Question')}
                        </Button>
                      </Space>
                    </>
                  )}
                >
                  {questionList && Array.isArray(questionList) && questionList.map((question, index) => (
                    <Option key={index} value={question.Id}>
                      {question.Question}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name="Id"></Form.Item>
              <Modal
                title={translation(translationCache, 'Add Item')}
                open={viewItemModal}
                okText={'Submit'}
                onOk={onFormItemSubmit}
                onCancel={onItemClose}
              >
                <Form
                  layout="vertical"
                  ref={ItemRef}
                  name="user_form"
                  onFinish={onFormItemSubmit}
                >
                  <Form.Item
                    label={translation(translationCache, 'Item')}
                    name={'Item'}
                    rules={[{ required: true }]}
                  >
                    <InputComponent
                      placeholder={translation(translationCache, 'Please enter Item')}
                    />
                  </Form.Item>
                </Form>
              </Modal>
              <Modal
                open={visible}
                width={800}
                closable
                title={translation(translationCache, constant.selectEquipment)}
                onOk={onModalOk}
                onCancel={onDrawerCancel}
              >
                <TableSelect
                  data={tableData}
                  translationCache={props.translationCache}
                  key="Equipment"
                  columns={[
                    {
                      title: translation(translationCache, 'Equipment'),
                      dataIndex: 'DeviceCode',
                      key: 'DeviceCode',
                      ...getColumnSearchProps('DeviceCode')
                    },
                    {
                      title: translation(translationCache, 'Equipment Description'),
                      dataIndex: 'Name',
                      key: 'Name',
                      ...getColumnSearchProps('Name')
                    }
                  ]}
                  handleDropdownChange={(e) => TableDropdownChange(e, 'visible')}
                />
              </Modal>
              <Modal
                title={translation(translationCache, constant.addArea)}
                open={viewAreaModal}
                okText={'Submit'}
                onOk={onFormAreaSubmit}
                onCancel={onAreaClose}
              >
                <Form
                  layout="vertical"
                  ref={areaRef}
                  name="user_form"
                  onFinish={onFormAreaSubmit}
                >
                  <Form.Item
                    label={translation(translationCache, constant.area)}
                    name={'Area'}
                    rules={[{ required: true }]}
                  >
                    <InputComponent placeholder={translation(translationCache, 'Enter Area')} />
                  </Form.Item>
                </Form>
              </Modal>
              <Modal
                title={translation(translationCache, 'Add Question')}
                open={viewQuestionModal}
                okText={'Submit'}
                width={700}
                onOk={onModalFormSubmit}
                onCancel={onQuestionsClose}
                footer={[
                  <Button key="Submit" onClick={onModalFormSubmit}>
                    {translation(translationCache, 'Submit')}
                  </Button>,
                  <Button key="Cancel" onClick={onQuestionsClose}>
                    {translation(translationCache, 'Cancel')}
                  </Button>
                ]}
              >
                <Form
                  ref={deviceRef}
                  name="user_form"
                  layout="vertical"
                  labelAlign="right"
                  labelWrap
                >
                  <Form.Item
                    label={translation(translationCache, 'Add Question')}
                    name={'Question'}
                    rules={[{ required: true }]}
                  >
                    <InputComponent
                      onChange={(e) => onAnswerChange(e)}
                      placeholder={translation(translationCache, 'Add Question')}
                    />
                  </Form.Item>
                  <Form.List name="Answers">
                    {(Answers, { add }) => (
                      <>
                        <Form.Item>
                          <Button
                            disabled={AnswerList && AnswerList.length === 0}
                            onClick={() => add()}
                            icon={<PlusOutlined />}
                          >
                            {translation(translationCache, 'Add Answers')}
                          </Button>
                        </Form.Item>
                        {Answers.map(({ key, name, ...restField }) => (
                          <Row key={key} gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                            <Col   span={12}>
                              <Form.Item
                                {...restField}
                                label={translation(translationCache, 'Answer')}
                                name={[name, 'Option']}
                                rules={[{ required: true }]}
                              >
                                <Select
                                  value={formObject && formObject.Answers ? formObject.Answers : []}
                                  placeholder={translation(translationCache, 'Select Answer')}
                                  onChange={(e) => onAnswerChange(e)}
                                  showArrow={true}
                                >
                                  {AnswerList && Array.isArray(AnswerList) && AnswerList.map((answers, index) => (
                                    <Option
                                      key={index}
                                      value={answers.Id}
                                      disabled={
                                        deviceRef.current &&
                                        deviceRef.current.getFieldsValue() &&
                                        deviceRef.current.getFieldsValue()['Answers'] &&
                                        deviceRef.current.getFieldsValue()['Answers'][index] &&
                                        deviceRef.current.getFieldsValue()['Answers'][index]['Option'] === answers.Id
                                      }
                                    >
                                      {translation(props.translationCache, answers.Answer)}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col   span={12}>
                              <Form.Item
                                {...restField}
                                label={translation(translationCache, 'Select WorkPlan')}
                                name={[name, 'Actions']}
                                rules={[{ required: false }]}
                              >
                                <Select
                                  placeholder={translation(translationCache, 'Select WorkPlan')}
                                  mode="multiple"
                                  showArrow={false}
                                >
                                  {WorkPlanList && Array.isArray(WorkPlanList) && WorkPlanList.map((answers, index) => (
                                    <Option key={index} value={answers.Code}>
                                      {answers.Name}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>
                          </Row>
                        ))}
                      </>
                    )}
                  </Form.List>
                </Form>
              </Modal>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(InspectionMaster);